import React from "react";
import Dashboard from "./Dashboard";
import TemperatureChart from "./TemperatureChart";
function App() {
  return (
    <>
      <Dashboard />
      <TemperatureChart />
    </>
  );
}
export default App;
